
  import { Vue, Component, Prop } from "vue-property-decorator";

  import UPDATE_USER_APPLICATION from "@/apollo/jobboard/UpdateUserApplication.gql";

  import UIButton from "@/components/button/ui-button.vue";

  import RouteNames from "@/entities/RouteNames";

  @Component({
    components: {
      UIButton,
    }
  })
  export default class InterviewButton extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId?: string;
    @Prop({ type: String, required: true }) readonly applicantUserId?: string;
    @Prop({ type: String, required: true }) readonly applicantName?: string;
    @Prop({type: String, required: true}) readonly jobTitle!: string;
    @Prop({type: String, default: ""}) readonly interviewedBy!: string;
    @Prop({type: String, required: true}) readonly applicationId!: string;
    @Prop({type: String, required: false, default: 'linkButton'}) readonly variant!: string;
    @Prop({type: String, required: false, default: 'no'}) readonly size!: string;
    @Prop({type: Boolean, required: false, default: false}) readonly disabled!: boolean;

    async interviewApplicant(): Promise<void> {
      const message = `Hello, ${this.applicantName}! Thank you for applying for ${this.jobTitle} position. We would like to invite you to an interview`;

      await this._createInterview();

      this.$router.push({
        name: RouteNames.INBOX,
        query: { recipientUserId: this.applicantUserId },
        params: {
          message,
        },
      });
    }

    async _createInterview(): Promise<void> {
      const variables = {
        where: {
          id: { _eq: this.applicationId},
        },
        set: {
          interviewed_by: this.currentUserId,
        }
      }

      await this.$apollo.mutate({
        mutation: UPDATE_USER_APPLICATION,
        variables,
      })
    }
  }
